import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './config/i18nConfig';
import * as actions from './store/actions/authAction';

import AppVersionChangeNotifier from './utils/appLevelUtility/appVersionChangeNotifierUtil';
import { useLocation } from 'react-router';
import RouteLoader from './config/route/RouteLoader';
import { base64UrlDecode } from './utils/utility';
import NetworkConnectionStatus from './shared/components/NetworkStatus/NetworkConnectionStatus';
// import ChatBot from './ChatBot';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { ApplicationDetailModel } from './store/models/applicationDetailModel';
import { RootState } from './store';
import IDCardModal from './shared/components/IDCardModal/IDCardModal';
import { NewAdmissionState } from './store/models/newAdmissionModel';
import ApplicationDetail from './shared/services/applicationDetail.service';

const App = (): ReactElement => {
  const { authCheckState } = actions;
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const searchParam = new URLSearchParams(search);
  const access_token = searchParam.get('access_token');
  const navigateToRoute = searchParam.get('route');
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const { getHealthIdCard } = useSelector((state: RootState): NewAdmissionState => state?.newAdmission || {});
  const applicationDetail = ApplicationDetail.instance;
  const tagManagerArgs = {
    gtmId: 'GTM-WPPVXVW',
    dataLayer: {
      userId: appDetail.getProviderId(),
      userName: appDetail.getProviderName(),
      hospitalUserId:  appDetail.getUserId(),
      hospitalUserName: appDetail.getUserName(),
      rohiniId: applicationDetail.getRohiniCode(),
      emailId: appDetail.getUserEmail(),
      message: 'GTM Connection initiated',
    },
  };
  TagManager.initialize(tagManagerArgs);

  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_CODE || '');
  if (pathname === '/' && access_token) {
    dispatch(actions.logout());
  }
  useEffect((): void => {
    if (pathname === '/' && access_token) {
          let decodedRoute = '';
          if (navigateToRoute) {
            decodedRoute = base64UrlDecode(navigateToRoute);
          }
          if (decodedRoute) {
            dispatch(actions.setAuthRedirectPath(decodedRoute));
          }
          dispatch(actions.ssoLogin(access_token));
    } else {
      dispatch(authCheckState());
    }
  }, [dispatch, authCheckState]);

  return (
    <div>
      <RouteLoader />
      <AppVersionChangeNotifier />
      <NetworkConnectionStatus />
      {/* <ChatBot /> */}
      {getHealthIdCard ? <IDCardModal /> : null}
    </div>
  );
};

export default App;
